<template>
  <div>
    <el-dialog
      top="20px"
      width="1000px"
      :title="title"
      append-to-body
      @close="close"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题" :label-width="formLabelWidth">
              <el-input v-model="form.NAME" placeholder="请输入记录名称" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="执行人" :label-width="formLabelWidth">
              <ayb-select-user
                ref="allUserDialog"
                :userId="cookieUser.userId"
                :idArray="userId"
                :isRadio="true"
                :setWidth="'100%'"
                @getValue="ExcuteUserGetValue"
              ></ayb-select-user>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="占任务百分比" :label-width="formLabelWidth">
              <el-input-number v-model="form.PERCENTAGE" style="width: 130px;"></el-input-number>
              <span>%</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="预计时间" :label-width="formLabelWidth">
              <el-date-picker
                v-model="TIME"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions2"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="计划内容" :label-width="formLabelWidth">
              <editor
                v-model="form.MEMO"
                ref="planEditor"
                :height="100"
                placeholder="请输入计划内容"
                :isClear="isClear"
              ></editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="截图" label-width="100px">
              <el-button @click="captureStart" type="primary" size="mini">截图</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="截图设置" label-width="100px">
              <el-checkbox v-model="form.hideWindow">隐藏当前窗口</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="添加附件" label-width="100px">
              <div
                style="display:inline-block;margin:1px"
                :id="FileUploaderId"
                class="PlanFilePicker"
              >上传附件</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-row v-if="isEdit">
              <fileListView :fileList="existFileList" @del="onFileDelete"></fileListView>
            </el-row>
          </el-col>
          <el-col :span="24">
            <div class="file-panel" :style="filePanelHeight" v-show=" fileList.length>0">
              <h2>文件列表</h2>
              <div class="file-list" :style="filePanelHeight">
                <ul
                  class="file-item"
                  :key="file.id"
                  :class="`file-${file.id}`"
                  v-for="file in fileList"
                >
                  <li class="file-type" :icon="fileCategory(file.ext)"></li>
                  <li class="file-name">{{file.name}}</li>
                  <li class="file-size">{{fileSize(file.size)}}</li>
                  <li class="file-status">上传中...</li>
                  <li class="file-operate">
                    <!--<a title="开始" @click="resume(file)">
                      <i class="el-icon-caret-right"></i>
                    </a>
                    <a title="暂停" @click="stop(file)">
                      <i class="el-icon-video-pause"></i>
                    </a>-->
                    <a title="移除" @click="remove(file)">
                      <i class="el-icon-delete"></i>
                    </a>
                  </li>
                  <li class="progress"></li>
                </ul>
                <div class="no-file" v-if="!fileList.length">
                  <i class="el-icon-files"></i> 暂无待上传文件
                </div>
              </div>
              <vue-upload
                ref="uploader"
                :uploadButton="'#'+FileUploaderId"
                multiple
                :formData="formData"
                @fileChange="fileChange"
                @progress="onProgress"
                @success="fileUploadCompleted"
              ></vue-upload>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
        <el-button type="danger" @click="dialogFormVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cap from "@/capturn/capturnwrapper.js";
import {
  AddOrUpdateWorkPlan,
  GetFileInfoByTaskId,
  DelAttachFile
} from "@/api/modules/basicData/task";
import selectContactor from "@/components/basicData/selectContactorComponent.vue";
import Editor from "@/components/common/editor";
import { MergeFile } from "@/api/modules/basicData/task";
import vueUpload from "@/components/basicData/upload";
import { getToken } from "@/util/auth";
import fileListView from "@/components/common/fileListView.vue";
const user = getToken();
const date = new Date();
const date2 = new Date();
date2.setDate(date.getDate() + 7);
export default {
  name: "SideTagsAddPlan",
  components: {
    Editor,
    selectContactor,
    vueUpload,
    fileListView
  },
  props: {
    mainId: {
      type: String
    }
  },
  mounted() {},
  data() {
    return {
      cookieUser: user,
      userId: [user.userId],
      isClear: true,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      title: "添加任务计划",

      form: {
        NAME: "",
        EXCUTEUSERID: "",
        EXCUTEUSERNAME: "",
        EXCUTEDEPTID: "",
        EXCUTEDEPTNAME: "",
        EXCUTECOMPANYID: "",
        EXCUTECOMPANYNAME: "",
        PERCENTAGE: "0",
        BEGINTIME: date,
        ENDTIME: date2,
        PLANTIME: "0",
        PLANWORKLOADUNIT: "0",
        PROCESS: "0",
        COMPLETEINFO: "",
        MEMO: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
        hideWindow: true
      },
      TIME: [date, date2],
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

      fileList: [],
      filePathList: [],
      formData: { guid: this.Guid() },
      filePanelHeight: { height: "60px" },
      FileUploaderId: "FileUploaderId",
      isEdit: false,
      existFileList: [],
      deletedFileList: []
    };
  },
  computed: {
    tabIndex: function() {
      return this.$store.state.task.tabIndex;
    },
    uploader() {
      return this.$refs.uploader;
    }
  },
  methods: {
    loadPlan: function(data) {
      this.reset();
      this.form = Object.assign({}, data);
      this.title = "编辑工作计划";

      this.TIME = [data.BEGINTIME, data.ENDTIME];
      this.userId = [data.EXCUTEUSERID + ""];
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.userId = [data.EXCUTEUSERID + ""];
        this.$refs.planEditor.setContent(this.form.MEMO);
      });
      let i = document.querySelectorAll(".PlanFilePicker").length;
      this.FileUploaderId = "FileUploaderId-" + i;
      // 附件列表
      this.isEdit = true;
      GetFileInfoByTaskId(data.ID, 101)
        .then(res => {
          res.forEach(c => {
            c._id = c.ID;
            c.ID = this.IMGAPI_ROOT + "api/Task/DownloadFileById?id=" + c.ID;
          });
          this.existFileList = res;
        })
        .catch(err => {
          console.log("文件列表获取失败！");
        });
    },
    showDialog: function() {
      this.dialogFormVisible = true;
      this.reset();
    },
    reset() {
      this.userId = [user.userId];
      this.form.EXCUTEUSERID = user.userId;
      this.form.EXCUTEUSERNAME = user.realName;
      this.form.EXCUTEDEPTID = user.departmentId;
      this.form.EXCUTEDEPTNAME = user.departmentName;
      this.form.EXCUTECOMPANYID = user.companyId;
      this.form.EXCUTECOMPANYNAME = user.companyName;
      this.form.MEMO = "";
      this.form.hideWindow = true;

      this.form.NAME = "";
      this.form.PERCENTAGE = "0";
      this.TIME = [date, date];
      this.fileList = [];
      this.filePathList = [];
      this.filePanelHeight = { height: "60px" };
      this.existFileList = [];
      this.deletedFileList = [];

      if (this.$refs.uploader) {
        this.$refs.uploader.destroy();
        this.$refs.uploader.initWebUpload();
      }
    },
    close() {
      console.log("asd");
      this.$refs.allUserDialog.reset();
    },
    ExcuteUserGetValue(data) {
      if (data.length == 0) return;
      const row = data[0];
      this.form.EXCUTEUSERID = row.UserId;
      this.form.EXCUTEUSERNAME = row.Name;
      this.form.EXCUTEDEPTID = row.DeptId;
      this.form.EXCUTEDEPTNAME = row.DeptName;
      this.form.EXCUTECOMPANYID = row.CompanyId;
      this.form.EXCUTECOMPANYNAME = row.CompanyName;

      console.log("executeUser", data);
    },
    onSubmit() {
      console.log("user", user);
      let paras = {
        NAME: this.form.NAME,
        CREATEUSERID: user.userId,
        CREATEUSERNAME: user.realName,
        CREATEDEPTID: user.departmentId,
        CREATEDEPTNAME: user.departmentName,
        CREATECOMPANYID: user.companyId,
        CREATECOMPANYNAME: user.companyName,
        EXCUTEUSERID: this.form.EXCUTEUSERID,
        EXCUTEUSERNAME: this.form.EXCUTEUSERNAME,
        EXCUTEDEPTID: this.form.EXCUTEDEPTID,
        EXCUTEDEPTNAME: this.form.EXCUTEDEPTNAME,
        EXCUTECOMPANYID: this.form.EXCUTECOMPANYID,
        EXCUTECOMPANYNAME: this.form.EXCUTECOMPANYNAME,
        MAINID: this.mainId,
        BEGINTIME: this.TIME[0],
        ENDTIME: this.TIME[1],
        PLANTIME: 1,
        MAINTYPE: 0,
        PROCESS: this.form.PROCESS,
        PERCENTAGE: this.form.PERCENTAGE,
        PLANWORKLOADUNIT: this.form.PLANWORKLOADUNIT,
        PLANTIME: this.form.PLANTIME,
        COMPLETEINFO: this.form.COMPLETEINFO,
        CREATETIME: this.form.CREATETIME,
        PLANINSTANCE: this.form.PLANINSTANCE,
        MEMO: this.$refs.planEditor.getContent(),
        ID: this.form.ID
      };
      console.log(paras);
      AddOrUpdateWorkPlan(paras, this.filePathList).then(pmevent => {
        if (pmevent.ResultCode === 1) {
          // this.initalTask();
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "保存任务计划成功。"
          });
          this.$emit("successed");
        } else {
          this.$message({
            type: "error",
            message: "保存任务计划失败！"
          });
        }
      });
      DelAttachFile(this.deletedFileList.join(",")).then(res => {
        console.log(res);
      });
    },
    captureStart() {
      // 截图开始
      cap.StartCapture(this.form.hideWindow, this);
    },
    fileChange(file) {
      if (!file.size) return;
      this.fileList.push(file);

      this.filePanelHeight = { height: this.fileList.length * 60 + "px" };
      console.log(file);
    },
    onProgress(file, percent) {
      $(`.file-${file.id} .progress`).css("width", percent * 100 + "%");
      $(`.file-${file.id} .file-status`).html((percent * 100).toFixed(2) + "%");
    },
    fileUploadCompleted(file, response) {
      console.log(file);
      console.log(response.guid);
      MergeFile(response.guid, response.f_ext).then(data => {
        console.log("合并：", data);
        if (data) {
          this.filePathList.push(data);
        } else {
          this.$message.error("文件合并失败！");
        }
      });
    },
    fileCategory(ext) {
      let type = "";
      const typeMap = {
        image: ["gif", "jpg", "jpeg", "png", "bmp", "webp"],
        video: ["mp4", "m3u8", "rmvb", "avi", "swf", "3gp", "mkv", "flv"],
        text: [
          "doc",
          "txt",
          "docx",
          "pages",
          "epub",
          "pdf",
          "numbers",
          "csv",
          "xls",
          "xlsx",
          "keynote",
          "ppt",
          "pptx"
        ]
      };
      Object.keys(typeMap).forEach(_type => {
        const extensions = typeMap[_type];
        if (extensions.indexOf(ext) > -1) {
          type = _type;
        }
      });
      return type;
    },
    fileSize(size) {
      return WebUploader.Base.formatSize(size);
    },
    resume(file) {
      this.uploader.upload(file);
    },
    stop(file) {
      this.uploader.stop(file);
    },
    remove(file) {
      // 取消并中断文件上传
      this.uploader.cancelFile(file);
      // 在队列中移除文件
      this.uploader.removeFile(file, true);

      // 在ui上移除
      let index = this.fileList.findIndex(ele => ele.id === file.id);
      this.fileList.splice(index, 1);
      this.filePanelHeight = { height: this.fileList.length * 60 + "px" };
    },
    onFileDelete(id) {
      this.deletedFileList.push(id);
    }
  }
};
</script>

<style scoped>
.PlanFilePicker {
  font-size: 12px;
  line-height: normal;
}
</style>
